
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { Box, Stack, Typography, useTheme, Zoom, Tooltip } from "@mui/material";
import Icon from "../../../../Icon/Icon";
import { ChipInfo } from "../../../../MainComponents/ChipInfo/ChipInfo";
import { useConstants } from "../Main/useConstants";
import { InvestigationItemContainer } from "../components/InvestigationItemContainer";
import { InvestigationButton } from "../components/InvestigationButton";


// Involucrado para la vista en la lista
export const InvolvedView = ({
  index,
  color,
  involved,
  setSelectedInvolved,
  setShowDrawer,
  justView,
  hide,
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const { enums, functions } = useConstants();

  const handleViewInfo = () => {
    setSelectedInvolved({...involved, index});
    setShowDrawer(true);
  }

  if (hide) return <></>;

  return (
    <InvestigationItemContainer 
      color={color}
      sx={{ padding: 2 }} 
    >
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Typography fontSize={16} fontWeight={600} color={color} >
            {involved.name}
          </Typography>
          <Tooltip
            title={
              involved.confirm_text === "confirmed" ? 
              t("involved.confirmed") :
              involved.confirm_text === "cant_confirm" ? 
              t("involved.not_confirmed") :
              involved.confirm_text === "out" ? 
              t("involved.not_participated") :
              involved.confirm_text === true ? 
              t("involved.confirmed") :
              t("involved.pending_confirmation")
            }
            placement="bottom"
            arrow
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 150 }}
          >
            <Box ml={.5}>
              <Icon 
                name={
                  involved.confirm_text === "confirmed" ? 
                  "bold_tick_circle" :
                  involved.confirm_text === "cant_confirm" ? 
                  "bold_danger" :
                  involved.confirm_text === "out" ? 
                  "bold_close_circle" :
                  involved.confirm_text === true ? 
                  "bold_tick_circle" :
                  "bold_info_circle"
                }
                color={
                  involved.confirm_text === "confirmed" ? 
                  theme.palette.green.main :
                  involved.confirm_text === "cant_confirm" ? 
                  theme.palette.orange.main :
                  involved.confirm_text === "out" ? 
                  theme.palette.red.main :
                  involved.confirm_text === true ? 
                  theme.palette.green.main :
                  theme.palette.yellow.main
                }
                size={16} 
              />
            </Box>
          </Tooltip>
        </Box>
        <Stack direction="row" spacing={1} alignItems="center">
          <ChipInfo 
            label={
              <span style={{ color: theme.palette.blueGray.main }}>
                {t("involved.indicated_by")}: &nbsp;
                  <b style={{ color: theme.palette.oxfordBlue.main }}>
                    {
                      (involved.indicated?.from === involved.added) ? 
                      functions.getUserLabel({ from: enums.typeUser.COMPLAINANT }) :
                      functions.getUserLabel(involved?.indicated) ?? "Otro"
                    }
                  </b>
              </span>
            }
            icon={<Icon name="bold_user_receive" size={24} />}
            color="secondary"
            maxWidth={200}
          />
          {
            !justView &&
            <InvestigationButton 
              icon="outline_clipboard_eye"
              sx={{ marginRight: 1 }}
              variant="primary" onClick={handleViewInfo}
            />
          }
        </Stack>
      </Box>
    </InvestigationItemContainer>
  )
};